import React from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import LayoutRoutes from './LayoutRoutes'
import PrivateRoutes from './PrivateRoutes';
import SignIn from '../Auth';
import ForgotPassword from '../Auth/ForgotPassword';
import { useAuth } from '../Context/AuthContext';

export default function Routers() {
    const { user, isLoading } = useAuth();

    if (isLoading) return null;

    return (
        <BrowserRouter basename={'/'}>
            <Routes>
                {user ? (
                    <>
                        <Route path={`${process.env.PUBLIC_URL}`} element={<Navigate to={`${process.env.PUBLIC_URL}/dashboard`} />} />
                        <Route path={`/`} element={<Navigate to={`${process.env.PUBLIC_URL}/dashboard`} />} />
                    </>
                ) : (
                    <Route path={`/`} element={<Navigate to={`${process.env.PUBLIC_URL}/login`} />} />
                )}
                <Route path={"/"} element={<PrivateRoutes />}>
                    <Route path={`/*`} element={<LayoutRoutes />} />
                </Route>
                <Route path={`${process.env.PUBLIC_URL}/login`} element={<SignIn />} />
                <Route path={`${process.env.PUBLIC_URL}/forgot-password`} element={<ForgotPassword />} />
                <Route path={`${process.env.PUBLIC_URL}/forget_password`} element={<ForgotPassword />} />
            </Routes>
        </BrowserRouter>
    )
}